import type { InvestmentSummary } from "@eu.mdotm.api/sphere";
import type { ManualCreationFormProps } from "./spawn-createPortfolio";

/** The save dialog's fields as a draft's summary already has them. */
export function generateDefaultManualCreation(summary: InvestmentSummary): ManualCreationFormProps {
	return {
		baseCurrency: summary.baseCurrency,
		name: summary.name,
		primaryBenchmark:
			summary.primaryBenchmarkIdentifier && summary.primaryBenchmarkType
				? {
						benchmarkIdentifier: summary.primaryBenchmarkIdentifier,
						benchmarkType: summary.primaryBenchmarkType,
					}
				: undefined,
		investmentReference: {
			referenceIdentifier: summary.referenceIdentifier,
			referenceType: summary.referenceType,
		},
		fixedWeights: summary.fixedWeights ?? false,
		liveTrading: summary.liveTrading ?? false,
	};
}
